import repImageSpeaker from '../OrgImages/repimagespeaker.webp';

export const OrgRepLocationShowcase = () => {
  return (
    <section className='relative h-full w-full overflow-hidden bg-gray-800'>
      <img
        src={repImageSpeaker}
        alt=''
        loading='lazy'
        className='absolute inset-0 h-full w-full object-cover'
      />

      <div className='absolute right-8 top-8 max-w-[520px] text-left'>
        <h1 className="m-0 text-display-md font-bold text-white tracking-[-0.72px]">
          Every movement <br />
          needs a voice—thank <br />
          you for being one.
        </h1>
      </div>
    </section>
  );
};

